import script from "./DownloadDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadDocument.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadDocument.vue?vue&type=style&index=0&id=b6cdbc16&lang=css"

const __exports__ = script;

export default __exports__